import { DatePicker, Form, Input, InputNumber, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const currencies = ["DZD", "USD", "EUR"];
const paymentMethods = [
  {
    value: "Espéce",
    label: "cash",
  },
  {
    value: "Carte Bancaire",
    label: "creditCard",
  },
  {
    value: "Chéque",
    label: "check",
  },
  {
    value: "Virement",
    label: "bankTransfer",
  },
  {
    value: "Versement",
    label: "payment",
  },
];

export default function ExpenseForm({ schools, onSubmit, form }) {
  const { loading } = useSelector((state) => state?.expenses);
  const { t } = useTranslation();
  return (
    <Form
      layout="vertical"
      name="expense"
      id="expense_form"
      form={form}
      onFinish={onSubmit}
      disabled={loading}
      style={{
        maxWidth: 600,
        margin: "0 auto",
      }}
    >
      <Form.Item
        label={t("expenses.crud.form.label.school")}
        name="schoolId"
        rules={[
          {
            required: true,
            message: t("expenses.crud.form.error.label.required.school"),
          },
        ]}
      >
        <Select>
          {schools?.map((school) => (
            <Select.Option key={school?._id} value={school?._id}>
              {school?.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label={t("expenses.crud.form.label.purchaseDate")}
        name="purchaseDate"
        rules={[
          {
            required: true,
            message: t("expenses.crud.form.error.label.required.purchaseDate"),
          },
        ]}
      >
        <DatePicker style={{ width: "100%" }} allowClear />
      </Form.Item>
      <Form.Item
        label={t("expenses.crud.form.label.label")}
        name="titled"
        rules={[
          {
            required: true,
            message: t("expenses.crud.form.error.label.required.label"),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={t("expenses.crud.form.label.description")}
        name="description"
      >
        <TextArea rows={4} />
      </Form.Item>
      <Form.Item
        label={t("expenses.crud.form.label.paymentMethod")}
        name="paymentMethod"
        rules={[
          {
            required: true,
            message: t("expenses.crud.form.error.label.required.paymentMethod"),
          },
        ]}
      >
        <Select>
          {paymentMethods?.map((method) => (
            <Select.Option key={method?.value} value={method?.value}>
              {`${t(`expenses.paymentMethod.${method?.label}`)}`}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label={t("expenses.crud.form.label.currency")}
        name="currency"
        rules={[
          {
            required: true,
            message: t("expenses.crud.form.error.label.required.currency"),
          },
        ]}
      >
        <Select>
          {currencies?.map((currency) => (
            <Select.Option key={currency} value={currency}>
              {currency}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label={t("expenses.crud.form.label.amount")}
        name="amount"
        rules={[
          {
            required: true,
            message: t("expenses.crud.form.error.label.required.amount"),
          },
        ]}
      >
        <InputNumber style={{ width: "100%" }} min={1} />
      </Form.Item>
    </Form>
  );
}
